// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__18Nv5","rootMobile":"styles_rootMobile__b4s2l"};